import { render, staticRenderFns } from "./Prakerja.vue?vue&type=template&id=c71d11c0&scoped=true"
import script from "./Prakerja.vue?vue&type=script&lang=js"
export * from "./Prakerja.vue?vue&type=script&lang=js"
import style0 from "./Prakerja.vue?vue&type=style&index=0&id=c71d11c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d11c0",
  null
  
)

export default component.exports